import { AlloyButton, ComponentLoader } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ERROR_DOMAIN, ERROR_PATH } from '@app/constants/errorConstants';
import { emptyCart } from '@app/store/orders/actions';
import ExceptionFeedbackBySelector from '@app/components/common/Exception/ExceptionFeedbackBySelector';
import useAnalytics from '@app/hooks/useAnalytics';
import styles from './EmptyCartConfirmationModal.module.scss';
import { getUpdateGAItem } from '../../OrderItemsTable/utils';
import { STATUS } from '@app/constants/commonConstants';

const EmptyCartConfirmationModal = ({ closeModal }) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const { fireRemoveFromCartEvent } = useAnalytics();

  const storeName = useSelector(s => s.store?.name) || '';
  const emailCart = useSelector(s => s.common.emailCart);
  const emptyingCartStatus = useSelector(s => s.orders.emptyingCartStatus);

  const isEmptyingCart = emptyingCartStatus === STATUS.PENDING;

  const trackGA = items => {
    const gaItems = items.map(item =>
      getUpdateGAItem(item, item.quantity, storeName, emailCart)
    );
    fireRemoveFromCartEvent({ products: gaItems });
  };

  const deleteCartItems = () => {
    dispatch(emptyCart(trackGA)).then(res => {
      if (res?.type !== 'SET_ERROR') {
        closeModal();
      }
    });
  };

  return (
    <div className="d-print-none">
      {isEmptyingCart && <ComponentLoader contentClassName="position-sticky" />}
      <div className="pb-3">
        <ExceptionFeedbackBySelector
          selector={state =>
            state?.errors?.[ERROR_DOMAIN.CART]?.[
              ERROR_PATH.EMPTY_CART_EMPTY_MODAL
            ]
          }
          errorCodeLabel={'MLP_ERROR4'}
        />
        <p
          className={`mt-3 ${styles['empty-cart-confirmation-modal__empty-cart']}`}
        >
          {t('SHOPCART_EMPTY_CART_MSG')}
        </p>
        <div className="mt-3">
          <div className="d-lg-inline-block">
            <AlloyButton
              buttonType="secondary"
              data-testid="emptyCartButton"
              className="col-md-12"
              size="dynamic"
              onClick={deleteCartItems}
            >
              {t('YES_EMPTY_CART')}
            </AlloyButton>
          </div>

          <AlloyButton
            buttonType="ghost"
            onClick={closeModal}
            className="col-lg-3 col-md-12 pt-lg-2 pt-md-4"
          >
            {t('NO_CANCEL')}
          </AlloyButton>
        </div>
      </div>
    </div>
  );
};

EmptyCartConfirmationModal.propTypes = {
  closeModal: PropTypes.func.isRequired
};

export default EmptyCartConfirmationModal;
